module.exports = __webpack_public_path__ + "static/media/swab_logo.08e04629.png";